module.exports = __webpack_public_path__ + "static/32-90f586ea6b7f86747ac365a077cbf0fa.jpg";